import React, { useEffect } from 'react';
import Routes from './Routes';
import Login from './pages/login/Login';
import OAuthLogin from './pages/oauth-login/OAuthLogin';
import AuthValidate from './pages/auth-validate/AuthValidate';
import CreatePassword from './pages/create-password/CreatePassword';
import PwaLogin from './pages/pwa-login/PwaLogin';
import PwaHome from './pages/pwa-home/PwaHome';
import PwaBondInsuranceAnalysis from './pages/pwa-bond-insurance/PwaBondInsuranceAnalysis';
import PwaPreAnalysisList from './pages/pwa-pre-analysis-list/PwaPreAnalysisList';
import PwaNewAnalysis from './pages/pwa-new-analysis';
import PwaFireInsuranceBudget from './pages/pwa-fire-insurance-budget';
import RecoveryPassword from './pages/recovery-password/RecoveryPassword';
import ProtectedRoute from './components/ProtectedRoute';
import { Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PageMaintenance from './pages/MaintenancePage';
import FireInsuranceBudgetIframe from './pages/iframe/fire-insurance-budget';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles';
import { initializeGA } from './services/analytics';
import { usePwaInstall, isPwa } from './utils/pwaUtils';

const App = () => {
  const { isInstalled } = usePwaInstall();

  useEffect(() => {
    initializeGA();
    if (isPwa()) {
      console.log('Running in PWA mode');
      // Potential analytics event here
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <meta name="google" content="notranslate" />
      </Helmet>
      <Route path="/" exact component={Login} />
      <Route path="/login" component={OAuthLogin} />
      <Route path="/auth-validate" component={AuthValidate} />
      <Route path="/create-password" component={CreatePassword} />
      <Route path="/pwa/login" component={PwaLogin} />
      <ProtectedRoute path="/pwa/home" component={PwaHome} />
      <ProtectedRoute path="/pwa/bond-insurance-analysis" component={PwaBondInsuranceAnalysis} />
      <ProtectedRoute path="/pwa/fire-insurance-budget" component={PwaFireInsuranceBudget} />
      <ProtectedRoute path="/pwa/pre-analyses" component={PwaPreAnalysisList} />
      <ProtectedRoute path="/pwa/new-analysis" component={PwaNewAnalysis} />
      <Route path="/recovery-password" component={RecoveryPassword} />
      <Route path={`/manutencao`} component={PageMaintenance} />
      <Route path="/iframe/fire-insurance-budget" component={FireInsuranceBudgetIframe} />
      <ProtectedRoute path="/admin" component={Routes} />
    </ThemeProvider>
  );
};

export default App;
